// CompareArticle.js
// Template for a single comparison page. Reads :slug from the route, looks up
// metadata in compareData, injects per-article SEO, and renders the matching
// article component from ARTICLE_COMPONENTS. Unknown/unpublished slug ->
// redirect to /compare.
//
// To add a comparison: import its component and add one line to
// ARTICLE_COMPONENTS keyed by slug (must match the compareData slug + route).

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CompareLayout from './CompareLayout';
import { getComparisonBySlug, colors } from './compareData';
import { useCompareSeo } from './useCompareSeo';

// --- Article component registry ---
import TeeTimeHelperAlternative from './articles/TeeTimeHelperAlternative';
import GolfLeagueTrackerAlternative from './articles/GolfLeagueTrackerAlternative';

const ARTICLE_COMPONENTS = {
  'tee-time-helper-alternative': TeeTimeHelperAlternative,
  'golf-league-tracker-alternative': GolfLeagueTrackerAlternative,
};

export default function CompareArticle() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const cmp = getComparisonBySlug(slug);
  const ArticleComponent = ARTICLE_COMPONENTS[slug];

  // SEO hook runs unconditionally (hooks rule); no-ops on missing comparison.
  useCompareSeo(cmp && cmp.published ? cmp : null);

  useEffect(() => {
    if (!cmp || !cmp.published || !ArticleComponent) {
      navigate('/compare', { replace: true });
    }
  }, [cmp, ArticleComponent, navigate]);

  if (!cmp || !cmp.published || !ArticleComponent) {
    return null; // redirecting
  }

  return (
    <CompareLayout maxWidth={760}>
      <nav style={{ display: 'flex', gap: 18, marginBottom: 24, fontSize: 14 }}>
        <span
          onClick={() => navigate('/compare')}
          style={{ color: colors.green700, fontWeight: 600, cursor: 'pointer' }}
        >
          ← All comparisons
        </span>
        <span
          onClick={() => navigate('/')}
          style={{ color: colors.gray500, fontWeight: 600, cursor: 'pointer' }}
        >
          Home
        </span>
      </nav>
      <ArticleComponent />
    </CompareLayout>
  );
}
